export const PRIVILEGE_GET_ALL = "V1_PRIVILEGE_GET_ALL";